import { api } from 'src/api/axios';

export const useCheckAcrylicSize = (idAcrylicSize: any) =>
  api.get(`/api/cms/acrylic-plate/check-deletion-size/${idAcrylicSize}`);
